module.exports = __webpack_public_path__ + "static/media/gallery.12c0835f.svg";